import type React from 'react';
import { LulaLogoBaseSvg } from 'src/assets/icons/logos/LulaLogoBaseSvg';

interface Props {
  headerText: string;
}

const AuthHeader: React.FC<Props> = ({ headerText }) => (
  <div className="ls-auth-top-section">
    <div className="ls-auth-logo">
      <LulaLogoBaseSvg />
    </div>
    <h4>{headerText}</h4>
  </div>
);

export default AuthHeader;
